import ExpandableMenu from 'assets/core/js/module/expandable-menu'

export default function (): ExpandableMenu[] {
  const expandableMenus: ExpandableMenu[] = []

  document.querySelectorAll('.search-form__wrapper .dca-expandable__menu').forEach(function (el) {
    expandableMenus.push(new ExpandableMenu(el))
  })

  return expandableMenus
}
